import { IStyle } from '@fluentui/react';
import { IH2OTheme, Sizes } from '@h2oai/ui-kit';

export interface IPendingPermissionListStyles {
  root?: IStyle;
  list?: IStyle;
}

export interface IPendingPermissionListClassNames {
  root: string;
  list: string;
}

export const pendingPermissionListStylesDefault = (theme: IH2OTheme): Partial<IPendingPermissionListStyles> => ({
  root: {
    height: '100%',
    backgroundColor: theme.semanticColors?.contentBackground,
    padding: '8px 16px 0px 16px',
    borderRadius: Sizes.borderRadius,
  },
  list: {
    height: '100%',
    overflow: 'auto',
  },
});
